import { render, staticRenderFns } from "./SoliStatCard.vue?vue&type=template&id=1c3b9609&scoped=true"
import script from "./SoliStatCard.vue?vue&type=script&lang=js"
export * from "./SoliStatCard.vue?vue&type=script&lang=js"
import style0 from "./SoliStatCard.vue?vue&type=style&index=0&id=1c3b9609&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3b9609",
  null
  
)

export default component.exports